'use client';
import Button from '@/components/Button';
import CheckMark from '@/components/icons/CheckMark';
import CrossTimes from '@/components/icons/CrossTimes';
import { BootstrapContext, ToastContext } from '@/pagesComponents/Layout';
import Errors from '@/services/errors';
import { sendNewPassword } from '@/services/register';
import { AnimatePresence, motion } from 'motion/react';
import { useSearchParams } from 'next/navigation';
import { useContext, useState } from 'react';

const ResetPasswordCard = () => {
  const bootstrap = useContext(BootstrapContext);
  const searchParams = useSearchParams();
  const email = decodeURIComponent(searchParams.get('email'));
  const phoneCode = decodeURIComponent(searchParams.get('phoneCode'));
  const token = decodeURIComponent(searchParams.get('token'));

  const updateToast = useContext(ToastContext);

  const [passwordIsInvalid, setPasswordIsInvalid] = useState(true);
  const [passwordsDontMatch, setPasswordsDontMatch] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState({
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    isLongEnough: false,
  });
  const [displayEndFlow, setDisplayEndFlow] = useState({
    display: false,
    message: '',
    type: '',
  });

  // const validPasswordRegex = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{5,}$/);
  const validPasswordRegex = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{5,}$/);
  const hasUpperCase = RegExp(/[A-Z]/);
  const hasLowerCase = RegExp(/[a-z]/);
  const hasNumber = RegExp(/\d/);
  const isLongEnough = RegExp(/^.{5,}$/);

  const validatePassword = (password) => {
    setPasswordIsInvalid(!validPasswordRegex.test(password));
    setPasswordErrors(() => ({
      hasUpperCase: hasUpperCase.test(password),
      hasLowerCase: hasLowerCase.test(password),
      hasNumber: hasNumber.test(password),
      isLongEnough: isLongEnough.test(password),
    }));

    const confrimPassword = document.getElementById('ConfirmPassword').value;
    confirmPasswordsMatch(confrimPassword);

    return validPasswordRegex.test(password);
  };
  const confirmPasswordsMatch = (confirmPassword) => {
    const password = document.getElementById('PasswordReset').value;
    setPasswordsDontMatch(password !== confirmPassword);
    return password === confirmPassword;
  };
  const handleSUbmitNewPassword = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const dataToSend = Object.fromEntries(formData.entries());
    dataToSend.Email = email;
    dataToSend.PhoneCode = phoneCode;
    dataToSend.Token = token === 'null' ? null : token;
    const validPassword = validatePassword(dataToSend.Password);
    const passwordsMatch = confirmPasswordsMatch(dataToSend.ConfirmPassword);
    if (!validPassword || !passwordsMatch) {
      const messageObject = {
        message: 'Le formulaire n\'est pas valide',
        type: 'danger',
      };
      Errors.handleError(messageObject, updateToast);
      return;
    }

    try {
      const response = await sendNewPassword(dataToSend);
      const resoponseIsError = response instanceof Error;
      if (response instanceof Error) {
        const data = response;
        setDisplayEndFlow({
          display: true,
          message: data.message,
          type: 'danger',
        });
        Errors.handleError(data, updateToast);
      } else {
        updateToast({
          message: 'Votre mot de passe a été réinitialisé',
          type: 'success',
        });
        setDisplayEndFlow({
          display: true,
          message: 'Votre mot de passe a été réinitialisé',
          type: 'success',
        });
        setTimeout(() => {
          const toast = document.getElementById('default-toast');
          const toastInstance = bootstrap.Toast.getOrCreateInstance(toast);
          toastInstance.show();
        }, 100);
      }
      setTimeout(() => {
        setDisplayEndFlow({
          display: false,
          message: '',
          type: '',
        });
      }, 5000);
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
    }
  };

  return (
    <div className="card-body d-flex flex-column align-items-center">
      <AnimatePresence>
        {displayEndFlow.display && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className={`card alert alert-${displayEndFlow.type}`}
            dangerouslySetInnerHTML={{ __html: displayEndFlow.message }}
          ></motion.div>
        )}
      </AnimatePresence>

      <form className={'mb-2 w-100 w-md-50 w-sm-75'} onSubmit={(e) => handleSUbmitNewPassword(e)}>
        <input id="PhoneCode" name="PhoneCode" type="hidden" value={phoneCode || ''} readOnly={true} />
        <input id="Token" name="Token" type="hidden" value={token || ''} readOnly={true} />
        <div className="row form-group justify-content-center mb-2">
          <div className="col-12 col-md-6">
            <label className="form-label" htmlFor="resetPassword__Email">
              Email
            </label>
            <input
              id="resetPassword__Email"
              className="form-control"
              name="Email"
              readOnly={true}
              value={email || 'email@example.com'}
              disabled={true}
            />
          </div>
        </div>
        <div className="row justify-content-center mb-2">
          <div className="form-group col-8 col-md-6">
            <label className="form-label" htmlFor="PasswordReset">
              Mot de passe
            </label>
            <input
              id="PasswordReset"
              className="form-control"
              name="Password"
              type={'password'}
              required=""
              autoFocus={true}
              onChange={(e) => validatePassword(e.target.value)}
            />
            {passwordIsInvalid && (
              <small className="form-text text-danger">Le mot de passe n&apos;est pas valide</small>
            )}
          </div>
          <div className="form-group col-8 col-md-6">
            <label className="form-label" htmlFor="ConfirmPassword">
              Confirmer le mot de passe
            </label>
            <input
              id="ConfirmPassword"
              className="form-control"
              type="password"
              name="ConfirmPassword"
              required=""
              onChange={(e) => confirmPasswordsMatch(e.target.value)}
            />
            {passwordsDontMatch && (
              <small className="form-text text-danger">Les mots de passe ne correspondent pas</small>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <Button type="submit" className="btn btn-primary">
            Soumettre
          </Button>
        </div>
      </form>

      <div className="card w-100 w-md-50 w-sm-75">
        <div className="card-body">
          <h5 className="card-title">Votre mot de passe doit</h5>
          <ul className="card-text">
            <li>
              <div className={'d-flex align-items-center w-100  justify-content-between'}>
                avoir au moins une lettre en majuscule
                {passwordErrors.hasUpperCase ? (
                  <CheckMark fillColor={'success'} className={'size-5 ms-2 w-10'} />
                ) : (
                  <CrossTimes fillColor={'danger'} className={'size-6 ms-2 w-10'} />
                )}
              </div>
            </li>
            <li>
              <div className={'d-flex align-items-center  justify-content-between w-100 '}>
                avoir au moins une lettre en minuscule
                {passwordErrors.hasLowerCase ? (
                  <CheckMark fillColor={'success'} className={'size-5 ms-2 w-10'} />
                ) : (
                  <CrossTimes fillColor={'danger'} className={'size-6 ms-2 w-10'} />
                )}
              </div>
            </li>
            <li>
              <div className={'d-flex align-items-center  justify-content-between w-100 '}>
                avoir au moins un chiffre
                {passwordErrors.hasNumber ? (
                  <CheckMark fillColor={'success'} className={'size-5 ms-2 w-10'} />
                ) : (
                  <CrossTimes fillColor={'danger'} className={'size-6 ms-2 w-10'} />
                )}
              </div>
            </li>
            <li>
              <div className={'d-flex align-items-center  justify-content-between w-100 '}>
                être composé de 5 caractères minimun
                {passwordErrors.isLongEnough ? (
                  <CheckMark fillColor={'success'} className={'size-5 ms-2 w-10'} />
                ) : (
                  <CrossTimes fillColor={'danger'} className={'size-6 ms-2 w-10'} />
                )}
              </div>
            </li>
            <li>
              <div className={'d-flex align-items-center  justify-content-between w-100 '}>
                Les mots de passe correspondent
                {!passwordsDontMatch ? (
                  <CheckMark fillColor={'success'} className={'size-5 ms-2 w-10'} />
                ) : (
                  <CrossTimes fillColor={'danger'} className={'size-6 ms-2 w-10'} />
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordCard;
